// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"fd4c5507","171":"5265c13e","198":"8a72e49a","307":"fc142c7c","320":"2793c4c8","352":"24380570","404":"7e96fb7b","434":"ed0f6aee","668":"df84009e","787":"430cec7d","837":"1f49cfb7","939":"c2bf98ab","953":"4b01bd21"}[chunkId] + ".chunk.js";
};